import { render, staticRenderFns } from "./main-reference.vue?vue&type=template&id=5990a509&scoped=true"
import script from "./main-reference.vue?vue&type=script&lang=js"
export * from "./main-reference.vue?vue&type=script&lang=js"
import style0 from "./main-reference.vue?vue&type=style&index=0&id=5990a509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990a509",
  null
  
)

export default component.exports